const useAsset = () => {
  const ASSET_URL = 'https://d25fziaz6eob8p.cloudfront.net/assets';

  return {
    ASSET_URL,
  };
};

export default useAsset;
